import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type {
    OnboardingStepRecord,
    OnboardingStepsSliceState,
} from './onboardingSteps.type';

export const ONBOARDING_STEPS_REDUCER_NAME = 'onboardingSteps';

const onboardingStepsInitialState: OnboardingStepsSliceState = {
    data: [],
};

export const onboardingStepsSlice = createSlice({
    name: ONBOARDING_STEPS_REDUCER_NAME,
    initialState: onboardingStepsInitialState,
    reducers: {
        setOnboardingSteps: (
            state,
            action: PayloadAction<OnboardingStepRecord[]>,
        ) => {
            state.data = action.payload;
        },
        resetOnboardingSteps: (state) => {
            state.data = [];
        },
    },
});

export const { setOnboardingSteps, resetOnboardingSteps } =
    onboardingStepsSlice.actions;

export const onboardingStepsReducer = onboardingStepsSlice.reducer;
